import React, { useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ButtonOverride from "../../../components/buttonoverride";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import useApi from '../../../hooks/use-api';
import { PrepareNullableDataForSend, ReplaceNullsWithEmptyStrings } from "../../../utilities/rhfdatanormalizationfunctions";
import useMessageStore from "../../../stores/message-store";
import { useOutletContext } from "react-router-dom";

const ApplicationFormNew = () => {
    const [isLoading,setIsLoading] = useState(true); //Default to true
    const [popGroups,setPopGroups] = useState([]);
    const [levelOfCare,setLevelOfCare] = useState([]);
    const [guardianTypes,setGuardianTypes] = useState([]);
    const [maritalStatuses,setMaritalStatuses] = useState([]);
    const [relationshipStatuses,setRelationshipStatuses] = useState([]);
    const [referralSources,setReferralSources] = useState([]);
    const [states,setStates] = useState([]);
    const [counties,setCounties] = useState([]);

    const [receivedByAdminStaffList,setReceivedByAdminStaffList] = useState([]);
    const [stateTransitionAssignedList,setStateTransitionAssignedList] = useState([]);
    const [MedicaidVerifyList,setMedicaidVerifyList] = useState([]);
    const [InstitutionalizedVerifyList,setInstitutionalizedVerifyList] = useState([]);
    const [regionalTCList,setRegionalTCList] = useState([]);

    const {ApplicationID} = useOutletContext();

    const initialValues = {
        populationgroup: '',
        levelofcare: '',
        referraldate: '',
        receivedbyadmin: '',
        facilityadmitdate: '',
        facilitydischargedate: '',
        currentfacility: '',
        facilityphone: '',
        facilityaddress: '',
        facilitystate: '',
        facilitycity: '',
        facilitycounty: '',
        facilityzip: '',
        facilitycontact: '',
        facilitycontactphone: '',
        clientphone: '',
        clientemail: '',
        maritalstatus: '',
        guardianstatus: '',
        name: '',
        relationshipstatus: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        todiscusscontactperson: '',
        todiscusscontactemail: '',
        todiscusscontactphone: '',
        referralsource: '',
        referralsourceother: '',
        sttassigned: '',
        medicaidrecipient: '',
        medicaidrecipientverified: '',
        institutionalized90: '',
        institutionalizedverified: '',
        anticipatedtransitiondate: '',
        previoushomeaddress: '',
        previouscity: '',
        previousstate: '',
        previouszip: '',
        preferredtransitionlocation: '',
        counties: [],
        vision: '',
        mobility: '',
        safety: '',
        other: '',
        actions: '',
        housingreferral: '',
        transitioncoordinatorassigned: '',
        tccontactperson: '',
        tccontactphone: '',
        dateoftelephonecontact: '',
        scheduledappointmentdate: '',
        dateappointmentoccured: '',
        tcnotes: '',
        informationformsgiventoclient: '',
        informationformsgiventoclientdate: '',
        rightsandresgiventoclient: '',
        rightsandresgiventoclientdate: '',
        clientcompletedconsentform: '',
        clientcompletedconsentformdate: ''

    }

    const {getRequest,patchRequest} = useApi();

    const {handleSubmit,register,control,watch,resetField,reset,formState: {isDirty,isSubmitting}} = useForm({defaultValues: initialValues});

    const StringToBoolean = (item) => {
        if(item === null)
            return null;

        return item === 'true' ? true : false;
    }

    const addToast = useMessageStore(state => state.addToast);

    const _handleSubmit = async(values) => {
        const sendData = PrepareNullableDataForSend(values);

        sendData.medicaidrecipient = StringToBoolean(sendData.medicaidrecipient);
        sendData.institutionalized90 = StringToBoolean(sendData.institutionalized90);
        sendData.informationformsgiventoclient = StringToBoolean(sendData.informationformsgiventoclient);
        sendData.rightsandresgiventoclient = StringToBoolean(sendData.rightsandresgiventoclient);
        sendData.clientcompletedconsentform = StringToBoolean(sendData.clientcompletedconsentform);

        const [data,status] = await patchRequest('UpdateApplicationForm',{ApplicationID: ApplicationID,...sendData});
        
        const normalizedData = ReplaceNullsWithEmptyStrings(data);

        if(status === 200){
            addToast(
                {
                    id: Math.random(),
                    body: "The Application was succesfully updated!",
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                }
            )

            reset(
                {
                    ...normalizedData,
                    counties: data.counties.sort((a,b) => a-b),
                    medicaidrecipient: `${data.medicaidrecipient}`,
                    institutionalized90: `${data.institutionalized90}`,
                    informationformsgiventoclient: `${data.informationformsgiventoclient}`,
                    rightsandresgiventoclient: `${data.rightsandresgiventoclient}`,
                    clientcompletedconsentform: `${data.clientcompletedconsentform}`
                }
            );
        }
        else{
            addToast(
                {
                    id: Math.random(),
                    body: "An error occured when updating the application.",
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                }
            )
        }
    }

    const FindInactiveItems = (id,searchList = [],masterList = []) => {
        if(id === null || searchList.some(item => item.id === id)) return searchList; //Return base list if item doesn't exist
        
        if(!searchList.find(item => item.id === id)){
            const masterRef = masterList.find(item => item.id === id);
            if(!masterRef) return searchList; //If not found in master list return search list

            const inactiveItem = { ...masterRef,Inactive: true };
            const updatedList = [...searchList,inactiveItem];

            return updatedList.sort((a,b) => a.name.localeCompare(b.name));
        }  
    }

    
    const getAll = async() => {
        setIsLoading(true);

        const[typesData,formData] = await Promise.all([
            getRequest('ApplicationFormDefinitions',{timestamp: Date.now()}),
            getRequest('ApplicationForm',{ApplicationID: ApplicationID,timestamp: Date.now()})
        ]);

        const [extractedTypeData,typeStatus] = typesData;
        const [extractedFormData,formStatus] = formData;

        if(typeStatus === 200 && formStatus === 200){
            setPopGroups(extractedTypeData.popgroups);
            setLevelOfCare(extractedTypeData.levelofcare);
            setReceivedByAdminStaffList(FindInactiveItems(extractedFormData.receivedbyadmin,extractedTypeData.adminstaff,extractedTypeData.usermasterlist));
            setMedicaidVerifyList(FindInactiveItems(extractedFormData.medicaidrecipientverified,extractedTypeData.adminstaff,extractedTypeData.usermasterlist));
            setInstitutionalizedVerifyList(FindInactiveItems(extractedFormData.institutionalizedverified,extractedTypeData.adminstaff,extractedTypeData.usermasterlist));
            setStateTransitionAssignedList(FindInactiveItems(extractedFormData.sttassigned,extractedTypeData.sttlist,extractedTypeData.usermasterlist));
            setRegionalTCList(FindInactiveItems(extractedFormData.transitioncoordinatorassigned,extractedTypeData.rttlist,extractedTypeData.usermasterlist));
            setGuardianTypes(extractedTypeData.guardiantypes);
            setMaritalStatuses(extractedTypeData.maritalstatuses);
            setRelationshipStatuses(extractedTypeData.relationshipstatuses);
            setReferralSources(extractedTypeData.referralsources);
            setStates(extractedTypeData.states);
            setCounties(extractedTypeData.counties);

            const formValues = ReplaceNullsWithEmptyStrings(extractedFormData);

            reset(
                {
                    ...formValues,
                    counties: formValues.counties.sort((a,b) => a-b),
                    medicaidrecipient: `${formValues.medicaidrecipient}`,
                    institutionalized90: `${formValues.institutionalized90}`,
                    informationformsgiventoclient: `${formValues.informationformsgiventoclient}`,
                    rightsandresgiventoclient: `${formValues.rightsandresgiventoclient}`,
                    clientcompletedconsentform: `${formValues.clientcompletedconsentform}`


                }
            );
        }
        else{

        }

        setIsLoading(false);
    }

    useEffect(() => {
        getAll();
    },[])

    const referralSource = watch('referralsource');
    const countiesSelected = watch('counties');
    const adminstaffvalue = watch('receivedbyadmin');
    const medicaidverifyvalue = watch('medicaidrecipientverified');
    const Institutionalizedverifyvalue = watch('institutionalizedverified');
    const sttValue = watch('sttassigned');
    const rttValue = watch('transitioncoordinatorassigned');

    useEffect(() => {
        if(referralSource){
            const hasFollowup = referralSources.find(item => item.id === referralSource).hasfollowup;

            if(!hasFollowup){
                resetField('referralsourceother',{defaultValue: initialValues.referralsourceother});
            }
        }
        else{
            resetField('referralsourceother',{defaultValue: initialValues.referralsourceother});
        }
    },[referralSource])

    if(isLoading){
        return(
            <div>loading...</div>
        )
    }

    const _checkInactive = (id,list = []) => {
        return id !== ''
        ?
            list.find(item => item.id === parseInt(id))?.Inactive
        :
            false
    }

    const adminStaffError = _checkInactive(adminstaffvalue,receivedByAdminStaffList);
    const medicaidVerifyError = _checkInactive(medicaidverifyvalue,MedicaidVerifyList);
    const InstitutionalizedVerifyError = _checkInactive(Institutionalizedverifyvalue,InstitutionalizedVerifyList);
    const sttError = _checkInactive(sttValue,stateTransitionAssignedList);
    const rttError = _checkInactive(rttValue,regionalTCList);


    const colLength = Math.ceil(counties.length / 3);
    const countyColumns = Array.from({length: 3},(_,i) => counties.slice(i * colLength,(i + 1) * colLength));

    const hasRefSourceFollowup = referralSource
     ? 
        referralSources.find(item => item.id === referralSource).hasfollowup
     : 
        false;
    
    return(
        <form onSubmit={handleSubmit(_handleSubmit)}>
            <div className="clientCard">
                <div className="clientCardInner">
                    <h3 className="text-center">Application Form</h3>
                    <div style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                        <Row>
                            <Col xs={12}>
                                <h4 className="text-center">Eligibility</h4>
                            </Col>
                            <Col xs={12} md={5}>
                                <fieldset>
                                    <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Pick one MFP target population group.</legend>
                                    {
                                        popGroups.map((item,index) => (
                                            <label key={item.id} className="me-4">
                                                <input {...register('populationgroup')} type="radio" id={`populationgroup${index}`} value={item.id} name="populationgroup"/>
                                                {item.name}
                                            </label>
                                        ))
                                    }
                                </fieldset>
                            </Col>
                            <Col xs={12} md={4}>
                                <fieldset>
                                    <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Level of Care</legend>
                                    {
                                        levelOfCare.map((item,index) => (
                                            <label key={item.id} className="me-4">
                                                <input {...register('levelofcare')} type="radio" id={`levelofcare${index}`} value={item.id} name="levelofcare"/>
                                                {/* <label htmlFor={`levelofcare${index}`}>{item.name}</label> */}
                                                {item.name}
                                            </label>
                                        ))
                                    }
                                </fieldset>
                            </Col>
                            <Col xs={12} md={3}>
                                <label htmlFor="referraldate">Referral Date</label>
                                <input type="date" id="referraldate" {...register('referraldate')} max={new Date().toISOString().split('T')[0]} style={{width: '100%'}}/>
                            </Col>
                            <Col xs={12} md={6}>
                                <label htmlFor="receivedbyadmin">Received by Admin Staff</label>
                                <select id="receivedbyadmin" {...register('receivedbyadmin')} style={{width: '100%',color: adminStaffError ? 'red' : 'black'}}>
                                    <option value='' style={{color: 'black'}}>--Select from the MFP Team List--</option>
                                    {
                                        receivedByAdminStaffList.map((item) => (
                                            <option key={item.id} value={item.id} style={{color: item.Inactive ? 'red' : 'black'}} disabled={item.Inactive}>{item.name} {item.Inactive ? <>-- No Longer Active</> : null}</option>
                                        ))
                                    }
                                </select>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={6} lg={4}>
                                <label htmlFor="facilityadmitdate">Facility Admit Date</label>
                                <input type="date" id="facilityadmitdate" {...register('facilityadmitdate')} style={{width: '100%'}}/>
                            </Col>
                            <Col xs={12} md={6} lg={4}>
                                <label htmlFor="facilitydischargedate">Facility Discharge Date</label>
                                <input type="date" id="facilitydischargedate" {...register('facilitydischargedate')} style={{width: '100%'}}/>
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-4" style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                        <Row>
                            <Col xs={12}>
                                <h4 className="text-center">Facility Information</h4>
                            </Col>
                            <Col xs={12} md={8}>
                                <label htmlFor="currentfacility">Current Facility</label>
                                <input type="text" id="currentfacility" {...register('currentfacility')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="facilityphone">Facility Phone</label>
                                <input type="text" id="facilityphone" {...register('facilityphone')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={8}>
                                <label htmlFor="facilityaddress">Facility Address</label>
                                <input type="text" id="facilityaddress" {...register('facilityaddress')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="facilitystate">Facility State</label>
                                <input type="text" id="facilitystate" {...register('facilitystate')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="facilitycity">Facility City</label>
                                <input type="text" id="facilitycity" {...register('facilitycity')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="facilitycounty">Facility County</label>
                                <input type="text" id="facilitycounty" {...register('facilitycounty')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="facilityzip">Facility Zip</label>
                                <input type="text" id="facilityzip" {...register('facilityzip')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="facilitycontact">Facility Contact</label>
                                <input type="text" id="facilitycontact" {...register('facilitycontact')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="facilitycontactphone">Facility Contact Phone</label>
                                <input type="text" id="facilitycontactphone" {...register('facilitycontactphone')} style={{width: '100%'}} />
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-4" style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                        <Row>
                            <Col xs={12}>
                                <h4 className="text-center">Client Information</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <h5 className="fw-bold">Client Contact Information</h5>
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="clientphone">Client Phone #</label>
                                <input id="clientphone" type="text" style={{width: '100%'}} {...register('clientphone')}/>
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="clientemail">Client Email</label>
                                <input id="clientemail" type="text" style={{width: '100%'}} {...register('clientemail')}/>
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="maritalstatus">Marital Status</label>
                                <select id="maritalstatus" {...register('maritalstatus')} style={{width: '100%',height: '30px'}}>
                                    <option value=''>--Select Marital Status--</option>
                                    {
                                        maritalStatuses.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={12}>
                                <h5 className="fw-bold">Guardian/POA/Family</h5>
                            </Col>
                            <Col xs={12}>
                                <fieldset>
                                    <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Guardian Status</legend>
                                    {
                                        guardianTypes.map((item,index) => (
                                            <label key={item.id} className="me-4">
                                                <input {...register('guardianstatus')} type="radio" id={`guardianstatus${index}`} value={item.id} name="guardianstatus"/>
                                                <label htmlFor={`guardianstatus${index}`}>{item.name}</label>
                                            </label>
                                        ))
                                    }
                                </fieldset>
                            </Col>
                            <Col xs={12} md={6}>
                                <label htmlFor="name">Name</label>
                                <input type="text" id="name" style={{width: '100%'}} {...register('name')} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="relationshipstatus">Relationship Status</label>
                                <select id="relationshipstatus" style={{width: '100%',height: '30px'}} {...register('relationshipstatus')}>
                                    <option value=''>--Select Relationship--</option>
                                    {
                                        relationshipStatuses.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </Col>
                            <Col xs={12} md={2}>
                                <label htmlFor="phone">Phone</label>
                                <input type="text" id="phone" style={{width: '100%'}} {...register('phone')} />
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="address">Address</label>
                                <input type="text" id="address" style={{width: '100%'}} {...register('address')} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="city">City</label>
                                <input type="text" id="city" style={{width: '100%'}} {...register('city')} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="State">State</label>
                                <input type="text" id="State" style={{width: '100%'}} {...register('state')} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="zip">Zip</label>
                                <input type="text" id="zip" style={{width: '100%'}} {...register('zip')} />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={12}>
                                <h5 className="fw-bold">To Discuss</h5>
                            </Col>
                            <Col xs={12} md={5}>
                                <label htmlFor="todiscusscontactperson">To Discuss Contact Person</label>
                                <input type="text" id="todiscusscontactperson" style={{width: '100%'}} {...register('todiscusscontactperson')} />
                            </Col>
                            <Col xs={12} md={5}>
                                <label htmlFor="todiscusscontactemail">To Discuss Contact Email</label>
                                <input type="text" id="todiscusscontactemail" style={{width: '100%'}} {...register('todiscusscontactemail')} />
                            </Col>
                            <Col xs={12} md={2}>
                                <label htmlFor="todiscusscontactphone">To Discuss Contact Phone</label>
                                <input type="text" id="todiscusscontactphone" style={{width: '100%'}} {...register('todiscusscontactphone')} />
                            </Col>   
                        </Row>
                        <Row className="mt-4">
                            <Col xs={12}>
                                <h5 className="fw-bold">Referral Information</h5>
                            </Col>
                            <Col xs={12} md={6}>
                                <label htmlFor="referralsource">Referral Source</label>
                                <select id="referralsource" style={{width: '100%',height: '30px'}} {...register('referralsource')}>
                                    <option value="">--Select Referral Source--</option>
                                    {
                                        referralSources.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </Col>
                            <Col xs={12} md={6}>
                                <label htmlFor="referralsourceother">Referral Source (Other)</label>
                                <input type="text" id="referralsourceother" style={{width: '100%'}} {...register('referralsourceother')} disabled={!hasRefSourceFollowup}/>
                            </Col>
                            <Col xs={12} md={6}>
                                <label htmlFor="sttassigned">State Transition Team Member Assigned</label>
                                <select id="sttassigned" style={{width: '100%',height: '30px',color: sttError ? 'red' : 'black'}} {...register('sttassigned')}>
                                    <option value='' style={{color: 'black'}}>--Select from the STT List--</option>
                                    {
                                        stateTransitionAssignedList.map((item) => (
                                            <option key={item.id} value={item.id} style={{color: item.Inactive ? 'red' : 'black'}} disabled={item.Inactive}>{item.name} {item.Inactive ? <>-- No Longer Active</> : null}</option>
                                        ))
                                    }
                                </select>
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-4" style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                        <Row>
                            <Col xs={12}>
                                <h4 className="text-center">Medical Information</h4>
                            </Col>
                            <fieldset>
                                <Row>
                                    <Col xs={12} md={6}>
                                            <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Medicaid recipient at least one day</legend>
                                            <label className="me-1">
                                                <input type="radio" value={true} name="medicaidrecipient" {...register('medicaidrecipient')}/>
                                                Yes
                                            </label>
                                            <label>
                                                <input type="radio" value={false} name="medicaidrecipient" {...register('medicaidrecipient')}/>
                                                No
                                            </label>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <label htmlFor="medicaidrecipientverified">Verified By</label>
                                        <select id="medicaidrecipientverified" {...register('medicaidrecipientverified')} style={{width: '100%',color: medicaidVerifyError ? 'red' : 'black'}}>
                                            <option value='' style={{color: 'black'}}>--Select from the MFP Team List--</option>
                                            {
                                                MedicaidVerifyList.map((item) => (
                                                    <option key={item.id} value={item.id} style={{color: item.Inactive ? 'red' : 'black'}} disabled={item.Inactive}>{item.name} {item.Inactive ? <>-- No Longer Active</> : null}</option>
                                                ))
                                            }
                                        </select>
                                    </Col>
                                </Row>
                            </fieldset>
                            <fieldset>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Institutionalized at least 90 days in facility</legend>
                                        <label className="me-1">
                                            <input type="radio" value={true} name="institutionalized90" {...register('institutionalized90')}/>
                                            Yes
                                        </label>
                                        <label>
                                            <input type="radio" value={false} name="institutionalized90" {...register('institutionalized90')}/>
                                            No
                                        </label>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <label htmlFor="institutionalizedverified">Verified By</label>
                                        <select id="institutionalizedverified" {...register('institutionalizedverified')} style={{width: '100%',color: InstitutionalizedVerifyError ? 'red' : 'black'}}>
                                            <option value='' style={{color: 'black'}}>--Select from the MFP Team List--</option>
                                            {
                                                InstitutionalizedVerifyList.map((item) => (
                                                    <option key={item.id} value={item.id} style={{color: item.Inactive ? 'red' : 'black'}} disabled={item.Inactive}>{item.name} {item.Inactive ? <>-- No Longer Active</> : null}</option>
                                                ))
                                            }
                                        </select>
                                    </Col>
                                </Row>
                            </fieldset>
                            <Col xs={12} md={6}>
                                <label htmlFor="anticipatedtransitiondate">Anticipated Transition Date</label>
                                <input type="date" id="anticipatedtransitiondate" style={{width: '100%'}} {...register('anticipatedtransitiondate')} />
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-4" style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                        <Row>
                            <Col xs={12}>
                                <h4 className="text-center">Client Preferences</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <h5 className="fw-bold">Previous Location Information</h5>
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="previoushomeaddress">Previous Home Address</label>
                                <input type="text" id="previoushomeaddress" {...register('previoushomeaddress')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={4}>
                                <label htmlFor="previouscity">Previous City</label>
                                <input type="text" id="previouscity" {...register('previouscity')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={4}>
                                <label htmlFor="previousstate">Previous State</label>
                                <select id="previousstate" {...register('previousstate')} style={{width: '100%',height: '30px'}}>
                                    <option value=''>--Select a state--</option>
                                    {
                                        states.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </Col>
                            <Col xs={4}>
                                <label htmlFor="previouszip">Previous Zip</label>
                                <input type="text" id="previouszip" {...register('previouszip')} style={{width: '100%'}} />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={12}>
                                <h5 className="fw-bold">Preferences</h5>
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="preferredtransitionlocation">Preferred Transition Location</label>
                                <input type="text" id="preferredtransitionlocation" {...register('preferredtransitionlocation')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} className="mt-2">
                                    <Controller
                                        control={control}
                                        name="counties"
                                        render={({field}) => (
                                            <fieldset style={{borderRadius: '12px', border: '1px solid black'}}>
                                                <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0',padding: '0px 6px'}}>Counties in which the client would consider living</legend>
                                                <div style={{padding: '8px 6px'}}>
                                                    <div style={{maxHeight: '200px',overflowY: 'auto',overflowX: 'hidden'}}>
                                                        <Row>
                                                            {
                                                                countyColumns.map((col,colIndex) => (
                                                                    <Col xs={12} md={4} key={colIndex}>
                                                                        {col.map((county) => (
                                                                            <div key={county.id}>
                                                                            <label>
                                                                                <input type="checkbox" value={county.id} checked={field.value.includes(county.id)}
                                                                                    onChange={(e) => {
                                                                                        const value = parseInt(e.target.value,10);

                                                                                        if(e.target.checked){
                                                                                            field.onChange([...field.value,value].sort((a,b) => a - b));
                                                                                        }
                                                                                        else{
                                                                                            field.onChange(field.value.filter((id) => id !== value));
                                                                                        }
                                                                                }} 
                                                                                />
                                                                                {county.name}
                                                                            </label>
                                                                            </div>
                                                                        ))}
                                                                    </Col>
                                                                ))
                                                            }
                                                        </Row>
                                                    </div>
                                                </div>
                                                {
                                                    countiesSelected.length > 0
                                                    &&
                                                    <div className="d-flex justify-content-between align-items-center flex-wrap" style={{padding: '0px 6px',borderBottomLeftRadius: '12px',borderBottomRightRadius: '12px',backgroundColor: 'white'}}>
                                                        <div className="d-flex">
                                                            <strong style={{marginRight: '0.5rem'}}>Selected Counties ({countiesSelected.length})</strong>
                                                            <div className="d-flex flex-wrap" style={{gap: '0.5rem'}}>
                                                                {
                                                                    countiesSelected.sort((a,b) => a - b).map((item,index) => {
                                                                        const countyItem = counties.find((county) => county.id === item);
                                                                        return countyItem ? <span key={index}>{countyItem.name}</span> : null
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                        <ButtonOverride className="w-auto p-0" title="Clear Selections" aria-label="Clear Selections" onClick={() => field.onChange([])}>
                                                            <FontAwesomeIcon icon={faMultiply} style={{color: 'red'}} size="xl"/>
                                                        </ButtonOverride>
                                                    </div>
                                            }
                                            </fieldset>
                                        )}
                                    />
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-4" style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                        <Row>
                            <Col xs={12}>
                                <h4 className="text-center">Functional Considerations</h4>
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="vision">Vision</label>
                                <textarea id="vision" rows={4} {...register('vision')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="mobility">Mobility</label>
                                <textarea id="mobility" rows={4} {...register('mobility')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="safety">Safety</label>
                                <textarea id="safety" rows={4} {...register('safety')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="other">Other</label>
                                <textarea id="other" rows={4} {...register('other')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="actions">Actions/Comments</label>
                                <textarea id="actions" rows={4} {...register('actions')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="housingreferral">Housing Referral</label>
                                <input type="text" id="housingreferral" {...register('housingreferral')} style={{width: '100%'}} />
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-4" style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                        <Row>
                            <Col xs={12}>
                                <h4 className="text-center">Transition Coordinator</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={5}>
                                <label htmlFor="transitioncoordinatorassigned">Regional TC assigned</label>
                                <select id="transitioncoordinatorassigned" {...register('transitioncoordinatorassigned')} style={{width: '100%',height: '30px',color: rttError ? 'red' : 'black'}}>
                                    <option value='' style={{color: 'black'}}>--Select from RTT list--</option>
                                    {
                                        regionalTCList.map((item) => (
                                            <option key={item.id} value={item.id} style={{color: item.Inactive ? 'red' : 'black'}} disabled={item.Inactive}>{item.name} {item.Inactive ? <>-- No Longer Active</> : null}</option>
                                        ))
                                    }
                                </select>
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="tccontactperson">TC Contact Person</label>
                                <input type="text" id="tccontactperson" {...register('tccontactperson')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={3}>
                                <label htmlFor="tccontactphone">TC Contact Phone</label>
                                <input type="text" id="tccontactphone" {...register('tccontactphone')} style={{width: '100%'}} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={4}>
                                <label htmlFor="dateoftelephonecontact">Date of telephone contact</label>
                                <input type="date" id="dateoftelephonecontact" max={new Date().toISOString().split('T')[0]} {...register('dateoftelephonecontact')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="scheduledappointmentdate">Scheduled Appointment Date</label>
                                <input type="date" id="scheduledappointmentdate" {...register('scheduledappointmentdate')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="dateappointmentoccured">Date Appointment Occured</label>
                                <input type="date" id="dateappointmentoccured" max={new Date().toISOString().split('T')[0]} {...register('dateappointmentoccured')} style={{width: '100%'}} />
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col xs={12}>
                                <label htmlFor="tcnotes">TC Notes</label>
                                <textarea id="tcnotes" {...register('tcnotes')} style={{width: '100%'}} rows={5} />
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col xs={12} md={4} className="mb-2">
                                <fieldset>
                                    <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Information forms given to client?</legend>
                                    <label className="me-1">
                                        <input type="radio" value={true} name="informationformsgiventoclient" {...register('informationformsgiventoclient')}/>
                                        Yes
                                    </label>
                                    <label>
                                        <input type="radio" value={false} name="informationformsgiventoclient" {...register('informationformsgiventoclient')}/>
                                        No
                                    </label>
                                    <div>
                                        <label htmlFor="informationformsgiventoclientdate">Information forms given to client date</label>
                                        <input type="date" id="informationformsgiventoclientdate" max={new Date().toISOString().split('T')[0]} {...register('informationformsgiventoclientdate')} style={{width: '100%'}} />
                                    </div>
                                </fieldset>
                            </Col>
                            <Col xs={12} md={4} className="mb-2">
                                <fieldset>
                                    <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Rights and Responsibilities given to client?</legend>
                                    <label className="me-1">
                                        <input type="radio" value={true} name="rightsandresgiventoclient" {...register('rightsandresgiventoclient')}/>
                                        Yes
                                    </label>
                                    <label>
                                        <input type="radio" value={false} name="rightsandresgiventoclient" {...register('rightsandresgiventoclient')}/>
                                        No
                                    </label>
                                    <div>
                                        <label htmlFor="rightsandresgiventoclientdate">Rights and Responsibilities given to client date</label>
                                        <input type="date" id="rightsandresgiventoclientdate" max={new Date().toISOString().split('T')[0]} {...register('rightsandresgiventoclientdate')} style={{width: '100%'}} />
                                    </div>
                                </fieldset>
                            </Col>
                            <Col xs={12} md={4} className="mb-2">
                                <fieldset>
                                    <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Client completed consent form?</legend>
                                    <label className="me-1">
                                        <input type="radio" value={true} name="clientcompletedconsentform" {...register('clientcompletedconsentform')}/>
                                        Yes
                                    </label>
                                    <label>
                                        <input type="radio" value={false} name="clientcompletedconsentform" {...register('clientcompletedconsentform')}/>
                                        No
                                    </label>
                                    <div>
                                        <label htmlFor="clientcompletedconsentformdate">Client completed consent form date</label>
                                        <input type="date" id="clientcompletedconsentformdate" max={new Date().toISOString().split('T')[0]} {...register('clientcompletedconsentformdate')} style={{width: '100%'}} />
                                    </div>
                                </fieldset>
                            </Col>
                        </Row>
                    </div>
                    <Row className="mt-4">
                        <Col xs={12}>
                            <div className="d-flex justify-content-end">
                                <Button type="submit" variant="primary" disabled={!isDirty || isSubmitting}>
                                    {
                                        isSubmitting
                                        ?
                                            <Spinner animation="border" size="sm" />
                                        :
                                            <>Save Changes</>
                                                                                
                                    }
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </form>
    )
}

export default ApplicationFormNew;